export default "__VITE_ASSET__508d8854__"